import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WorkspaceService } from '../../workspace/workspace.service';
import * as _ from 'lodash-es';
import { GlobalService } from './global.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalFactoryService {
  public modalFactory: any = {};

  constructor(
    private http: HttpClient,
    private workspaceService: WorkspaceService,
    private globalService: GlobalService
  ) {}

  getModal(_modalName: any, _data: any) {
    const filterParams = this.workspaceService.workspaceFactory.activeScreen.filters
      ? this.workspaceService.workspaceFactory.activeScreen.filters.getFilterParams()
      : {};

    const jsonObj: any[] = [];

    if (_.isArray(_data) && _data.length > 0) {
      _.each(_data, (item: any) => {
        jsonObj.push({
          leid: item.data.LEID || item.data.SOURCE_LEID,
          me_code: item.data.ME_CODE || item.data.ME || item.data.SOURCE_ME_CODE,
          cdr_number: item.data.CDR_NO || item.data.TAX_CODE || item.data.SOURCE_CDR_NO,
          consol_group_key: item.data.CONSOL_GROUP_KEY || item.data.FILING_GROUP,
          reporting_period: item.data.REPORTING_PERIOD || item.data.SOURCE_REPORTING_PERIOD,
          combination_key: item.data.COMBINATION_KEY || item.data.COMPL_COMBINATION_KEY || item.data.HO_COMBINATION_KEY,
          scenario_key: item.data.SCENARIO_KEY || filterParams.scenario || this.globalService.global.globalParams.scenario,
        });
      });
    } else if (_data?.rowData) {
      jsonObj.push({
        leid: _data.rowData.LEID,
        me_code: _data.rowData.ME_CODE || _data.rowData.ME,
        cdr_number: _data.rowData.CDR_NO || _data.rowData.TAX_CODE || _data.rowData.HO_CDR_NO,
        consol_group_key: _data.rowData.CONSOL_GROUP_KEY || _data.rowData.FILING_GROUP,
        reporting_period: _data.rowData.REPORTING_PERIOD || _data.rowData.SOURCE_REPORTING_PERIOD,
        combination_key: _data.rowData.COMBINATION_KEY || _data.rowData.COMPL_COMBINATION_KEY || _data.rowData.HO_COMBINATION_KEY,
        scenario_key: _data.rowData.SCENARIO_KEY || filterParams.scenario || this.globalService.global.globalParams.scenario,
      });
    } else {
      jsonObj.push({
        scenario_key: filterParams.scenario || this.globalService.global.globalParams.scenario,
      });
    }

    const data = new FormData();
    data.append('modal_name', _modalName);
    data.append('tax_year', filterParams.tax_year || this.globalService.global.globalParams.tax_year);
    data.append('scenario', filterParams.scenario || this.globalService.global.globalParams.scenario);
    data.append('jcd_key', this.globalService.global.globalParams.jcd_key);
    data.append('issue_id', this.globalService.global.globalParams.issue_id);
    data.append('issue_short_desc', this.globalService.global.globalParams.issue_short_desc);
    data.append('jsonObj', JSON.stringify(jsonObj));

    return this.http
      .post(environment.base_url + '/getScreenModal', data, { withCredentials: true })
      .pipe(
        map((response: any) => {
          this.modalFactory.response = response;
          return response;
        })
      );
  }
}
